import { SelectOption } from '@globaleris/ui.library'
import moment from 'moment'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { EnumCommodity } from '../../enums'
import {
  ChildSettlementGroupModel,
  ChildSettlementGroupRequestModelDTO,
  FetchSettlementGroupByContractRequest,
  NewSettlementGroupContractModel,
  NewSettlementGroupSubjectModel,
  PatchSettlementGroupContractModel,
  PatchSettlementGroupSubjectModel,
  SettlementGroup,
  SettlementGroupAggregatedEditBatchRequest,
  SettlementGroupContractModel,
  SettlementGroupContractMoveRequest,
  SettlementGroupPatchRequest,
  SettlementGroupPostRequest
} from './model/settlementGroups'

export const apiGetSettlementGroupsWithFlexibilities = async (): Promise<SettlementGroup[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/settlementGroups/SettlementGroupsWithFlexibilities`
  ).then(response => response.data)
}

export const apiGetSettlementGroupsWithContracts = async (): Promise<SettlementGroup[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/SettlementGroups/SettlementGroupsWithContracts`
    `${apiSuffixUrl}/api/settlementGroups/SettlementGroupsWithContracts`
  ).then(response => response.data)
}

export const apiGetSettlementGroupsVirtualBattery = async (): Promise<SettlementGroup[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/SettlementGroups/SettlementGroupsVirtualBattery`
    `${apiSuffixUrl}/api/settlementGroups/SettlementGroupsVirtualBattery`
  ).then(response => response.data)
}

export const apiGetSettlementGroupsBusinessGroup = async (): Promise<SettlementGroup[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    //`https://localhost:63910/api/SettlementGroups/SettlementGroupsBusinessGroup`
    `${apiSuffixUrl}/api/settlementGroups/SettlementGroupsBusinessGroup`
  ).then(response => response.data)
}

export const apiGetChildSettlementGroups = async (
  parentId: number
): Promise<ChildSettlementGroupModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/settlementGroups/GetChildSettlementGroups?parentId=${parentId}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiCreateChildSettlementGroup = async (
  request: ChildSettlementGroupRequestModelDTO
): Promise<ChildSettlementGroupModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/settlementGroups/CreateChildSettlementGroup`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiUpdateChildSettlementGroup = async (
  request: ChildSettlementGroupRequestModelDTO
): Promise<ChildSettlementGroupModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.patch(
    `${apiSuffixUrl}/api/settlementGroups/UpdateChildSettlementGroup`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiDeleteChildSettlementGroup = async (
  parentId: number,
  childId: number
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(
    `${apiSuffixUrl}/api/SettlementGroups(${parentId})/DeleteChildSettlementGroup(${childId})`
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiGetParentSettlementGroupOptions = async (): Promise<SelectOption[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/settlementGroups/GetParentSettlementGroupOptions`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchContractsBySgId = async (
  settlementGroupId: number
): Promise<SettlementGroupContractModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/settlementGroups/FetchContractsForSettlementGroupId?settlementGroupId=${settlementGroupId}`
    `${apiSuffixUrl}/api/settlementGroups/FetchContractsForSettlementGroupId?settlementGroupId=${settlementGroupId}`
  ).then(response => response.data)
}

export const apiPostSettlementGroups = async (
  request: SettlementGroupPostRequest
): Promise<SettlementGroup> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/settlementGroups`, request).then(
    response => response.data
  )
}

export const apiPatchSettlementGroups = async (
  request: SettlementGroupPatchRequest
): Promise<SettlementGroup> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.patch(
    // `https://localhost:59923/api/SettlementGroups`,
    `${apiSuffixUrl}/api/settlementGroups`,
    request
  ).then(response => response.data)
}

export const apiUpdateSettlementGroupBatch = async (
  request: SettlementGroupAggregatedEditBatchRequest
): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/SettlementGroups/UpdateSettlementGroupBatch`,
    request
  ).then(response => response.data)
}

export const apiDeleteSettlementGroup = async (settlementGroupId: number) => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(
    // `https://localhost:59923/api/settlementGroups/DeleteSettlementGroup(${settlementGroupId})`
    `${apiSuffixUrl}/api/settlementGroups/DeleteSettlementGroup(${settlementGroupId})`
  ).then(response => response.data)
}

export const apiFetchSettlementGroupsByContractID = async (
  request: FetchSettlementGroupByContractRequest
): Promise<SettlementGroup> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  const startDate = moment(request.startDate).format('YYYY-MM-DD')
  const endDate = request.endDate ? moment(request.endDate).format('YYYY-MM-DD') : null

  let query = `contractId=${request.contractID}&startDate=${startDate}`

  if (endDate) {
    query += `&endDate=${endDate}`
  }

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/settlementGroups/FetchSettlementGroupsByContractId?${query}`
  ).then(response => response.data)
}

export const apiFetchCommoditiesForSettlementGroup = async (
  settlementGroupId: number
): Promise<EnumCommodity[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/SettlementGroups/FetchCommodityForSettlementGroupId?settlementGroupId=${settlementGroupId}`
  ).then(response => response.data)
}

export const apiPostSettlementGroupContract = async (
  settlementGroupId: number,
  request: NewSettlementGroupContractModel[]
) => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    // `https://localhost:59923/api/SettlementGroups/CreateSettlementGroupContract?settlementGroupId=${settlementGroupId}`,
    `${apiSuffixUrl}/api/settlementGroups/CreateSettlementGroupContract?settlementGroupId=${settlementGroupId}`,
    request
  ).then(response => response.data)
}

export const apiPatchSettlementGroupContract = async (
  settlementGroupId: number,
  id: number,
  request: PatchSettlementGroupContractModel
) => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.patch(
    // `https://localhost:59923/api/settlementGroups/PatchSettlementGroupContract?settlementGroupId=${settlementGroupId}&id=${id}`,
    `${apiSuffixUrl}/api/settlementGroups/PatchSettlementGroupContract?settlementGroupId=${settlementGroupId}&id=${id}`,
    request
  ).then(response => response.data)
}

export const apiDeleteSettlementGroupContract = async (settlementGroupId: number, id: number) => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(
    // `https://localhost:59923/api/settlementGroups/DeleteSettlementGroupContract(${settlementGroupId})/Contract(${id})`
    `${apiSuffixUrl}/api/settlementGroups/DeleteSettlementGroupContract(${settlementGroupId})/Contract(${id})`
  ).then(response => response.data)
}

export const apiMoveSettlementGroupContract = async (
  request: SettlementGroupContractMoveRequest
) => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    // `https://localhost:59923/api/SettlementGroups/MoveSettlementGroupContract`,
    `${apiSuffixUrl}/api/settlementGroups/MoveSettlementGroupContract`,
    request
  ).then(response => response.data)
}

//-----  SUBJECTLIST -----

export const apiPostSettlementGroupSubjectList = async (
  settlementGroupId: number,
  request: NewSettlementGroupSubjectModel[]
) => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    //`https://localhost:63910/api/settlementGroups/CreateSettlementGroupSubjectList?settlementGroupId=${settlementGroupId}`,
    `${apiSuffixUrl}/api/settlementGroups/CreateSettlementGroupSubjectList?settlementGroupId=${settlementGroupId}`,
    request
  ).then(response => response.data)
}

export const apiPatchSettlementGroupSubjectList = async (
  settlementGroupId: number,
  id: number,
  request: PatchSettlementGroupSubjectModel
) => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.patch(
    //`https://localhost:63910/api/settlementGroups/PatchSettlementGroupSubject?settlementGroupId=${settlementGroupId}&subjectId=${id}`,
    `${apiSuffixUrl}/api/settlementGroups/PatchSettlementGroupSubject?settlementGroupId=${settlementGroupId}&subjectId=${id}`,
    request
  ).then(response => response.data)
}

export const apiDeleteSettlementGroupSubject = async (settlementGroupId: number, id: number) => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.delete(
    //`https://localhost:63910/api/settlementGroups/DeleteSettlementGroupSubject?settlementGroupId=${settlementGroupId}&subjectId=${id}`
    `${apiSuffixUrl}/api/settlementGroups/DeleteSettlementGroupSubject?settlementGroupId=${settlementGroupId}&subjectId=${id}`
  ).then(response => response.data)
}
//-----  END SUBJECTLIST -----
